export function initAutoContextNotification(notificationSelector) {
  const notifCloseButtonSelector = notificationSelector.querySelector(".js-auto-context-notification__button-close");
  const notificationLink = notificationSelector.querySelector(`[data-selectorid="js-toaster-cta"]`);
  showAutoContextToast(notificationSelector, true);
  notifCloseButtonSelector.addEventListener('click', () => {
    showAutoContextToast(notificationSelector, false);
  });
  notificationLink.addEventListener('click', () => {
    window.dispatchEvent(new Event("openStoreContextLayerInSearchMode"));
  });
  setTimeout(() => {
    showAutoContextToast(notificationSelector, false);
  }, 7000);
}
function showAutoContextToast(notificationSelector, toShow) {
  notificationSelector.classList.add(toShow ? 'show' : 'hide');
  notificationSelector.classList.remove(toShow ? 'hide' : 'show');
}